import Vue from "vue"

export const ProcessingStepperEventBus = new Vue()
